import { render, staticRenderFns } from "./responsiveDash.vue?vue&type=template&id=3b97adbb&scoped=true&"
import script from "./responsiveDash.vue?vue&type=script&lang=js&"
export * from "./responsiveDash.vue?vue&type=script&lang=js&"
import style0 from "./responsiveDash.vue?vue&type=style&index=0&id=3b97adbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97adbb",
  null
  
)

export default component.exports